// extracted by mini-css-extract-plugin
module.exports = {"container":"_1WFbj","triangle":"_108p-"};